<template>
  <Popup :ref="(el) => popup = el"
         class=""
         :title="$t('labels.android_apps')"
         @onClose="hide"
  >
    <div class="" v-if="qrCodeKey">
      <div class="d-flex justify-content-center w-100 align-items-center gap-xs">
        <input type="text" class="form-control" :value="qrCodeKey" readonly>
        <copy-button :value="qrCodeKey"></copy-button>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <vue-qrcode v-if="qrCodeValue" :value="qrCodeValue" tag="svg" style="border-radius: 10px; max-width: 400px" class="w-100" :options="{ width: '100%' }"></vue-qrcode>
    </div>
  </Popup>
</template>
<script lang="ts">
import {computed, defineComponent, ref} from 'vue'
import {reactive, toRefs} from '@vue/reactivity';
import Popup from "@/apps/public/components/Popup.vue";
import {$t, helper} from "@/service/CommonHelper";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import LoaderButton from "@/apps/public/components/LoaderButton.vue";
import { useStore } from 'vuex';
import TraderDeviceDTO from "@/models/TraderDeviceDTO";
import { api } from '@/service/APIClient';
import {dateHelper} from "@/service/DateHelper";
import CopyButton from "@/apps/public/components/CopyButton.vue";
import {useNotification} from "@kyvg/vue3-notification";

export default defineComponent({
  methods: {$t},
  components: {CopyButton, LoaderButton, FormInputWrapper, Popup},
  setup(props) {
    const notification = useNotification()
    const popup = ref<InstanceType<typeof Popup> | null>(null)
    const store = useStore()
    const state = reactive({
      qrCodeKey: null as string|null,
      qrCodeValue: null as string|null,
      device: {} as TraderDeviceDTO
    });

    const show = async (device: TraderDeviceDTO, version: string) => {

      popup.value?.show()
      try {
        const data = await api.devicesRegisterDevice(device.id, version);
        state.qrCodeValue = data.qrCodeData;
        state.qrCodeKey = data.key;
      } catch (e: any) {
        if (e.response && e.response.status === 400 && e.response.data) {
          for (const item of e.response.data) {
            notification.notify({type: 'error', title: helper.trans(`server_errors.${item.code}`, {}, item.message)});
          }
        } else {
          notification.notify({type: 'error', title: helper.trans(`server_errors.INTERNAL_ERROR`)});
          throw e
        }
      }

    }

    const hide = () => {
      popup.value?.hide()
    }

    return {
      ...toRefs(state),
      popup,
      helper,
      show,
      hide,
      dateHelper
    }
  }
})
</script>
